<template>
  <div class="wrap">
    <div class="to-use" @click="handleToUse" v-if="isMember">
      我已购买，点击查看权益
    </div>
    <div v-for="item in catesgorys" :key="item.id" :class="item.display_code">
      <div class="price-wrap">
        <span class="unit">¥</span>
        <span class="price">{{ computedPrice(item.desc, "price") }}</span>
        <div class="tips">立省¥{{ computedPrice(item.desc, "discount") }}</div>
      </div>
      <div
        v-if="!isLogin"
        class="btn"
        @click="handleOpenUp(item.display_code)"
        v-ans="{ event_id: 'package_item_click', item_code: item.display_code }"
      >
        立即登录
      </div>
    </div>
    <div class="service" @click="toServiceLink"></div>
    <div class="rule-btn" @click="showRule = !showRule">
      活动规则
      <van-icon name="arrow-down" class="arrow" v-if="!showRule" />
      <van-icon name="arrow-up" class="arrow" v-else />
    </div>
    <div class="rule-wrap" v-if="showRule" v-html="namespaceInfo.rule"></div>
  </div>
</template>

<script>
import {
  defineComponent,
  ref,
  onMounted,
  computed,
  watch,
} from "@vue/composition-api";
import Vue from "vue";

import { useRouter, useStore } from "@/components/use/base";
import useVisitorCategory from "@/use/useVisitorCategory";

import DrawPopup from "./DrawPopup.js";

const vm = Vue.prototype;

export default defineComponent({
  setup() {
    const router = useRouter();
    const store = useStore();
    const isMember = computed(() => store.state.isMember);
    const namespaceInfo = computed(() => store.state.namespaceInfo);
    const isLogin = computed(() => !!store.state.token);

    watch(isMember, (newVal) => {
      if (newVal) {
        router.replace("/index");
      }
    });

    const { fetchCategory, fetchPackage, fetchPaymethod, catesgorys } =
      useVisitorCategory();

    const showRule = ref(false);

    const computedPrice = (value, type) => {
      return value.split("｜")[{ price: 0, discount: 1 }[type]];
    };

    const handleOpenUp = async (code) => {
      if (!isLogin.value) {
        await login(code);
      }
    };

    const login = async (code) => {
      if (!isLogin.value) {
        await DrawPopup.show({
          form: code,
        });
        store.dispatch("fetchUserInfo");
      } else {
        vm.$toast("您已登陆");
      }
    };

    onMounted(async () => {
      if (isLogin.value && isMember.value) {
        router.replace("/index");
      }
      await Promise.all([fetchCategory(), fetchPackage(), fetchPaymethod()]);
    });

    const handleToUse = () => {
      router.push("./index");
    };

    const toServiceLink = () => {
      window.open("https://oakvip.s2.udesk.cn/im_client/?web_plugin_id=60193");
    };

    return {
      handleToUse,
      computedPrice,
      toServiceLink,
      showRule,
      isMember,
      namespaceInfo,
      catesgorys,
      isLogin,
      handleOpenUp,
    };
  },
});
</script>


<style lang="less" scoped>
.wrap {
  position: relative;
  background: url(https://common-h5-dev.xiangshuheika.com/static/upload/202503274349051dcbb99.png)
    #ffa347;
  background-repeat: no-repeat;
  background-size: 100%;
  min-height: 1660px;
  padding-bottom: 29px;
  overflow: hidden;
}

.service {
  position: absolute;
  background: url(https://common-h5-dev.xiangshuheika.com/static/upload/2025021320df8b659dd9.png);
  background-repeat: no-repeat;
  background-size: contain;
  box-shadow: 0px 3px 6px 0px rgba(205, 90, 13, 0.65);
  top: 554px;
  right: 11px;
  height: 48px;
  width: 48px;
  border-radius: 24px;
}

.LRTSMG12,
.LRTSMG01,
.LRTSMG03 {
  display: flex;
  position: absolute;
  flex-wrap: nowrap;
  align-items: end;
  box-sizing: border-box;
  padding: 0 14px 0 17px;
  justify-content: space-between;

  .unit {
    font-weight: 600;
    font-size: 22px;
    color: #000000;
    line-height: 30px;
  }
  .price-wrap {
    display: flex;
    align-items: end;
  }
  .price {
    font-weight: 600;
    font-size: 41px;
    color: #000000;
    line-height: 41px;
    margin-left: 4px;
  }
  .tips {
    background: url(https://common-h5-dev.xiangshuheika.com/static/upload/2025021199ef70279a1d3.png);
    background-repeat: no-repeat;
    background-size: 100%;
    width: 66px;
    height: 20px;
    padding-left: 9px;
    box-sizing: border-box;
    margin-bottom: 4px;
    margin-left: 1px;

    font-size: 10px;
    color: #ffffff;
    line-height: 12px;
    text-align: center;
    line-height: 20px;
  }
  .btn {
    margin-bottom: 4px;
  }
}

.LRTSMG01 {
  top: 442px;
  left: 16px;
  width: 168px;
  flex-wrap: wrap;
  justify-content: center;
  .btn {
    margin-top: 12px;
  }
}

.LRTSMG03 {
  top: 442px;
  left: 192px;
  width: 168px;
  flex-wrap: wrap;
  justify-content: center;
  .btn {
    margin-top: 12px;
  }
}

.LRTSMG12 {
  display: flex;
  top: 268px;
  left: 16px;
  width: 342px;
}

.btn {
  background: linear-gradient(#fc2342 0%, #ff7f00 100%);
  box-shadow: 0px 0px 0px 2px rgba(255, 166, 93, 0.6);
  border-radius: 25px;
  width: 130px;
  height: 32px;
  font-size: 18px;
  color: #ffffff;
  line-height: 32px;
  text-align: center;
}

.to-use {
  position: absolute;
  background: #e42100;
  border-radius: 12px 0px 0px 12px;
  padding: 3px 3px 4px 8px;
  right: 0;
  top: 12px;

  font-weight: 500;
  font-size: 10px;
  color: #ffffff;
  line-height: 10px;
}
.rule-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  transform: translateX(-50%);
  margin-top: 1642px;
  margin-left: 50%;
  width: 90px;
  height: 22px;
  border-radius: 11px;
  border: 1px solid #ffffff;
  font-weight: 500;
  color: #ffffff;
}

.rule-wrap {
  margin: 24px 24px 0;
  border-radius: 11px;
  border: 1px solid #ffffff;
  padding: 16px;
  color: #ffffff;
}
</style>